import React from 'react'
import { ConsultingForm } from '@/components/composed/finansingConsulting/ConsultingForm'
import { GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import type { IFinancingConsultingModalProps } from './types'
import './styles.scss'

export const LandingConsultingModal: React.FC<IFinancingConsultingModalProps> = props => {
  const { options } = props
  const title = options?.title ?? messages.title

  return (
    <section className="landingConsultingModal">
      <GlassMorphIcon className="landingConsultingModal__icon" image="attention-green" />
      <h3 className="landingConsultingModal__title">{title}</h3>

      <ConsultingForm
        className="landingConsultingModal__form"
        inputPlaceholder={messages.phone.placeholder}
        submitButtonModifiers={['green']}
        submitButtonClassname="landingConsultingModal__submit"
        requestMapper={options?.requestMapper}
        isShowUxFeedback={options?.isShowUxFeedback}
      />
    </section>
  )
}
